import React from 'react';

const EmptyComponent = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '40vh',
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
      }}
    >
      <img src={'/assets/img/notfound.svg'} />
      <p>Not Found</p>
    </div>
  );
};

export default EmptyComponent;
